<template>
    <div class="d-flex align-items-center flex-row gap-2 w-100">
        <span v-if="!disabled || isLoading">
            <vertragsdokumente_herunterladen_icon v-if="!isLoading"></vertragsdokumente_herunterladen_icon>
            <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </span>
        <span v-else>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-check-circle-fill text-success" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
            </svg>
        </span>
        <button 
            class="btn btn-vigo-1-500 rounded rounded-pill px-4 py-3 d-flex align-items-center justify-content-center"
            :disabled="disabled || isLoading"
            @click="$emit('click')"
        >
            {{ buttonText }}
        </button>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import vertragsdokumente_herunterladen_icon from './icons/vertragsdokumente_herunterladen_icon.vue';

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    isLoading: {
        type: Boolean,
        default: false
    }
});

defineEmits(['click']);

const buttonText = computed(() => {
    if (props.isLoading) {
        return 'Wird heruntergeladen...';
    }
    if (props.disabled) {
        return 'Vertragsdokumente heruntergeladen';
    }
    return 'Vertragsdokumente herunterladen';
});
</script>